/**
 * Country name → ISO code mapping + SVG flag component via flag-icons CSS.
 * Works cross-platform (Windows, Mac, Linux) — no emoji dependency.
 */

const COUNTRY_CODES: Record<string, string> = {
  'France': 'fr', 'United States': 'us', 'Germany': 'de', 'United Kingdom': 'gb',
  'Spain': 'es', 'Italy': 'it', 'Belgium': 'be', 'Switzerland': 'ch',
  'Canada': 'ca', 'Netherlands': 'nl', 'Brazil': 'br', 'India': 'in',
  'Japan': 'jp', 'Australia': 'au', 'Portugal': 'pt', 'Morocco': 'ma',
  'Algeria': 'dz', 'Tunisia': 'tn', 'Luxembourg': 'lu', 'China': 'cn',
  'Russia': 'ru', 'Mexico': 'mx', 'Argentina': 'ar', 'Colombia': 'co',
  'Turkey': 'tr', 'Poland': 'pl', 'Sweden': 'se', 'Norway': 'no',
  'Denmark': 'dk', 'Finland': 'fi', 'Austria': 'at', 'Ireland': 'ie',
  'Greece': 'gr', 'Czech Republic': 'cz', 'Czechia': 'cz', 'Romania': 'ro',
  'Hungary': 'hu', 'South Korea': 'kr', 'Thailand': 'th', 'Vietnam': 'vn',
  'Indonesia': 'id', 'Philippines': 'ph', 'Malaysia': 'my', 'Singapore': 'sg',
  'New Zealand': 'nz', 'South Africa': 'za', 'Egypt': 'eg', 'Nigeria': 'ng',
  'Kenya': 'ke', 'Israel': 'il', 'United Arab Emirates': 'ae', 'Saudi Arabia': 'sa',
  'Pakistan': 'pk', 'Bangladesh': 'bd', 'Sri Lanka': 'lk', 'Nepal': 'np',
  'Ukraine': 'ua', 'Croatia': 'hr', 'Serbia': 'rs', 'Bulgaria': 'bg',
  'Slovakia': 'sk', 'Slovenia': 'si', 'Lithuania': 'lt', 'Latvia': 'lv',
  'Estonia': 'ee', 'Malta': 'mt', 'Cyprus': 'cy', 'Iceland': 'is',
  'Chile': 'cl', 'Peru': 'pe', 'Ecuador': 'ec', 'Venezuela': 've',
  'Uruguay': 'uy', 'Paraguay': 'py', 'Bolivia': 'bo', 'Costa Rica': 'cr',
  'Panama': 'pa', 'Guatemala': 'gt', 'Cuba': 'cu', 'Dominican Republic': 'do',
  'Puerto Rico': 'pr', 'Jamaica': 'jm', 'Taiwan': 'tw', 'Hong Kong': 'hk',
  "Ivory Coast": 'ci', "C\u00f4te d'Ivoire": 'ci', 'Senegal': 'sn',
  'Cameroon': 'cm', 'Ghana': 'gh', 'Tanzania': 'tz', 'Ethiopia': 'et',
  'Madagascar': 'mg', 'Mozambique': 'mz', 'Angola': 'ao',
  'Democratic Republic of the Congo': 'cd', 'Republic of the Congo': 'cg',
  'Lebanon': 'lb', 'Jordan': 'jo', 'Iraq': 'iq', 'Iran': 'ir',
  'Qatar': 'qa', 'Kuwait': 'kw', 'Bahrain': 'bh', 'Oman': 'om',
  'Myanmar (Burma)': 'mm', 'Cambodia': 'kh', 'Laos': 'la',
  'Mongolia': 'mn', 'Kazakhstan': 'kz', 'Uzbekistan': 'uz',
  'Georgia': 'ge', 'Armenia': 'am', 'Azerbaijan': 'az',
  'Belarus': 'by', 'Moldova': 'md', 'North Macedonia': 'mk',
  'Albania': 'al', 'Bosnia and Herzegovina': 'ba', 'Montenegro': 'me', 'Kosovo': 'xk',
  'Haiti': 'ht', 'Honduras': 'hn', 'El Salvador': 'sv', 'Nicaragua': 'ni',
  'Trinidad and Tobago': 'tt', 'Barbados': 'bb', 'Bahamas': 'bs',
  'R\u00e9union': 're', 'Martinique': 'mq', 'Guadeloupe': 'gp', 'French Guiana': 'gf',
  'New Caledonia': 'nc', 'French Polynesia': 'pf', 'Mayotte': 'yt',
}

/** Get lowercase ISO code from country name */
export function getCountryCode(countryName: string): string | null {
  return COUNTRY_CODES[countryName] || null
}

/** CSS class for flag-icons: returns "fi fi-fr" or null */
export function countryFlagClass(countryName: string): string | null {
  const code = COUNTRY_CODES[countryName]
  if (!code) return null
  return `fi fi-${code}`
}

/** @deprecated — emoji flags don't work on Windows. Use countryFlagClass instead. */
export function countryToFlag(countryName: string): string {
  const code = COUNTRY_CODES[countryName]?.toUpperCase()
  if (!code) return ''
  return String.fromCodePoint(...[...code].map(c => 0x1F1E6 + c.charCodeAt(0) - 65))
}
